export default __webpack_public_path__ + "static/media/pacific_war.1eb350f5.png";